<div class="vb__utils__heading">
  <strong>
    {{ data.title }}
  </strong>
</div>